import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Landing from "./pages/Landing";
import Snapshot from "./pages/Snapshot";
import Audit from "./pages/Audit";
import AuditIntake from "./pages/AuditIntake";
import AuditPreview from "./pages/AuditPreview";
import PaidSuccess from "./pages/PaidSuccess";
import PaidCancel from "./pages/PaidCancel";
import PaidReport from "./pages/PaidReport";
import NextSteps from "./pages/NextSteps";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminAudits from "./pages/AdminAudits";
import AdminAuditDetail from "./pages/AdminAuditDetail";
import AdminPayments from "./pages/AdminPayments";
import AdminConsultations from "./pages/AdminConsultations";
import AdminImplementationRequests from "./pages/AdminImplementationRequests";

function Shell({ children }) {
  return (
    <div className="sf-app">
      <Navbar />
      <main className="sf-main">{children}</main>
      <Footer />
    </div>
  );
}

// Admin routes use their own layout (AdminLayout) — never wrap them in <Shell />.
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public + audit flow */}
        <Route path="/" element={<Shell><Landing /></Shell>} />
        <Route path="/audit/snapshot" element={<Shell><Snapshot /></Shell>} />
        <Route path="/audit" element={<Shell><Audit /></Shell>} />
        <Route path="/audit/email" element={<Shell><AuditIntake /></Shell>} />
        <Route path="/audit/intake" element={<Shell><AuditIntake /></Shell>} />
        <Route path="/audit/preview/:sessionId" element={<Shell><AuditPreview /></Shell>} />
        <Route path="/audit/paid/success/:sessionId" element={<Shell><PaidSuccess /></Shell>} />
        <Route path="/audit/paid/cancel/:sessionId" element={<Shell><PaidCancel /></Shell>} />
        <Route path="/audit/report/:sessionId" element={<Shell><PaidReport /></Shell>} />
        <Route path="/audit/next-steps/:sessionId" element={<Shell><NextSteps /></Shell>} />

        {/* Admin — own layout, NOT wrapped in customer Shell */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/audits" element={<AdminAudits />} />
        <Route path="/admin/audits/:sessionId" element={<AdminAuditDetail />} />
        <Route path="/admin/payments" element={<AdminPayments />} />
        <Route path="/admin/consultations" element={<AdminConsultations />} />
        <Route path="/admin/implementation-requests" element={<AdminImplementationRequests />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
